<template lang="pug">
validation-provider(mode="lazy", :rules="required ? 'required|perfis_setor_unique|perfis_externo' : ''", v-slot="{ errors }", name="cadastroUsuario/perfis" slim)
  app-label(
    label="Perfis:",
    :required="required"
  )
  el-select.full-width.input(
    v-model="perfisSelecionados",
    :class="{'erro' : errors.length}",
    multiple,
    value-key="id"
    filterable,
    placeholder="Selecione o(s) perfil(is) do usuário",
    @change="changePerfis",
    no-match-text="Nenhum perfil encontrado",
  )
    el-option-group(
      v-for="setor in perfisAgrupado",
      :key="setor.nome",
      :label="formatNomeSetor(setor.nome)",
    )
      el-option(
        v-for="perfil in setor.perfis"
        :key="perfil.id",
        :label="perfil.nome",
        :value="perfil"
      )
  span(v-if="errors[0] && value.length === 0").help.erro É necessário inserir pelo menos um perfil.
  span(v-else-if="errors[0]").help.erro {{errors[0]}}

</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import AppLabel from '@/components/AppLabel'

export default {

  components: {
    AppLabel
  },

  data () {
    return {
      perfisSelecionados: [],
      sizePerfisSelecionados: 0,
      perfisSelecionadosAnteriores: [],
      perfis: []
    }
  },

  props: {
    value: {
      type: Array,
      default () {
        return []
      }
    },
    usuarioTipo: {
      type: String,
      default: 'PF'
    },
    span: {
      type: Number,
      default: 12
    },
    errors: {
      default: () => [],
      type: Array
    },
    required: {
      default: true,
      type: Boolean
    },
    isFiltro: {
      type: Boolean,
      default: false
    },
    pessoa: {
      type: Object,
      default: null
    }

  },

  async created () {
    this.perfis = await this.findAllPerfis(this.pessoa)
    this.init()
  },

  computed: {

    perfisAgrupado () {
      if (!this.perfis) {
        return {}
      }

      if (this.isFiltro) {
        return this.perfisAgrupados(this.perfis)
      }

      if (this.usuarioTipo === 'PJ') {
        const filtrados = this.perfis.filter(perfil => perfil.modulo === 'CENTRAL_DO_INTERESSADO' || perfil.modulo === 'AGENDAMENTO')
        return this.perfisAgrupados(filtrados)
      }
      const perfisPessoaFisica = this.perfis.filter(perfil => perfil.codigo !== 'PREFEITURA')
      return this.perfisAgrupados(perfisPessoaFisica)
    }

  },

  methods: {
    ...mapActions({
      findAllPerfis: 'usuario/findAllPerfis'
    }),

    changePerfis (perfisSelecionados) {
      let perfis = this.transformPerfilStringToObject(perfisSelecionados)

      if (!perfis) {
        perfis = []
      }

      const perfisAnteriores = this.transformPerfilStringToObject(this.perfisSelecionadosAnteriores)

      if (this.sizePerfisSelecionados < perfis.length) {
        // adicionando perfil
        this.sizePerfisSelecionados++
        this.$emit('perfilAdicionado', perfis[perfis.length - 1])
      } else {
        // Comparar qual perfil foi excluido e chamar o removePerfil
        const perfilExcluido = this.differenceBetween(perfisAnteriores, perfis)
        this.removePerfil(perfilExcluido)
      }
      this.perfisSelecionadosAnteriores = _.cloneDeep(perfisSelecionados)
      this.$emit('input', perfis)
    },

    transformPerfilStringToObject (perfis) {
      if (perfis && perfis.length > 0) {
        return perfis
      }
    },

    cleanPerfis () {
      this.perfisSelecionados = []
      this.$emit('input', this.perfisSelecionados)
    },

    removePerfil (perfilExcluido) {
      this.sizePerfisSelecionados--

      const value = perfilExcluido

      this.$emit('perfilRemovido', value)
    },

    formatNomeSetor (setor) {
      if (setor === 'EXTERNO') {
        return 'Externo'
      } else if (setor === 'TECNICO_DE_CAMPO') {
        return 'Técnico de Campo'
      } else if (setor === 'PRODUTIVIDADE') {
        return 'Produtividade'
      } else if (setor === 'RELATORIOS') {
        return 'Relatórios'
      }
      return setor
    },

    init () {
      this.perfisSelecionados = this.value
      this.sizePerfisSelecionados = this.value.length
      this.perfisSelecionadosAnteriores = _.cloneDeep(this.perfisSelecionados)
    },

    /**
     * Verifica se existe algum elemento no primeiro array que não está incluso no segundo
     */
    differenceBetween (firstArray, secondArray) {
      let elementReturn = {}
      firstArray.forEach((element) => { // eslint-disable-line
        const objectNotInclused = secondArray.filter(el => el.id === element.id)

        if (objectNotInclused.length === 0) {
          elementReturn = element
        }
      })
      return elementReturn
    },

    perfisAgrupados (perfis) {
      const perfisGrupo = {}
      if (perfis) {
        perfis.forEach((perfil) => {
          const setor = perfil.setor ? perfil.setor.nome : 'Outros'
          if (!perfisGrupo[setor]) {
            perfisGrupo[setor] = {
              nome: setor,
              perfis: []
            }
          }
          perfisGrupo[setor].perfis.push(perfil)
        })
      }

      return perfisGrupo
    }

  }
}

</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.full-width-perfis {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/screens/portal/seguranca/components/AppInputPerfil.vue